import { ApiClient } from '@wrapforce/shared/api-client';

// The public quote page needs no auth token - a separate client keeps that
// explicit rather than reusing the authenticated `api` client's refresh path.
export const publicApi = new ApiClient({
  baseUrl: import.meta.env.VITE_API_URL as string,
  getAccessToken: async () => null,
});
